export default __webpack_public_path__ + "static/media/img12.013ad347.png";